import React from 'react';
import { useTranslation } from 'react-i18next';

import { PetCloudInput } from '../../../common/petCloud';
import { EditReimbursementModalButtons } from './EditReimbursementModalButtons';
import { RadioButton } from '../../../common/RadioButton';

import { EDIT_ROUTING_NUMBER_LENGTH } from '../../../../constants';
import { useDirectDepositContent } from './hooks/useDirectDepositContent';

import styles from '../css/DirectDepositContent.module.css';

const ACCOUNT_TYPES = { checking: 1, savings: 2 };

const DirectDepositContent = ({
  onCancel = () => { },
}) => {
  const { t } = useTranslation('myAccount');
  const {
    accountNumberError,
    bankAccountRef,
    confirmAccountNumberError,
    confirmAccountRef,
    handleAccountNumberChange,
    handleAccountTypeChange,
    handleArrowKeyPressed,
    handleConfirmAccountNumberChange,
    handleEditReimbursementAccept,
    handleEditReimbursementCancel,
    handleEditReimbursementSuccess,
    handleRoutingNumberChange,
    isBankFormInvalid,
    reimbursementData,
    reimbursementMethodUpdateSuccess,
    routingNumberError,
    routingNumberRef,
    updatingReimbursementMethod,
  } = useDirectDepositContent({ onCancel });

  return (
    <form
      className={styles.contentContainer}
      onSubmit={handleEditReimbursementAccept}
    >
      <h6>{t('reimbursementSection.editModal.directDeposit')}</h6>

      <fieldset className={styles.radioButtonsContainer}>
        <legend>{t('reimbursementSection.editModal.accountType')}</legend>

        <RadioButton
          blue
          checked={reimbursementData.AccountType === ACCOUNT_TYPES.checking}
          id="radio-checking"
          name="accountType"
          onChange={handleAccountTypeChange(ACCOUNT_TYPES.checking)}
        >
          {t('reimbursementSection.editModal.checking')}
        </RadioButton>

        <RadioButton
          blue
          checked={reimbursementData.AccountType === ACCOUNT_TYPES.savings}
          id="radio-savings"
          name="accountType"
          onChange={handleAccountTypeChange(ACCOUNT_TYPES.savings)}
        >
          {t('reimbursementSection.editModal.savings')}
        </RadioButton>
      </fieldset>

      <div className={styles.inputMargin}>
        <PetCloudInput
          ariaProps={{
            'aria-label': t('reimbursementSection.editModal.routingNumber'),
          }}
          error={routingNumberError}
          id="bankRoutingNumber"
          inputRef={routingNumberRef}
          maxLength={EDIT_ROUTING_NUMBER_LENGTH}
          onBlur={handleRoutingNumberChange}
          onChange={handleRoutingNumberChange}
          onKeyDown={handleArrowKeyPressed()}
          pattern="[0-9]*"
          placeholder={t('reimbursementSection.editModal.routingNumber')}
          title={t('reimbursementSection.editModal.routingNumber')}
          type="number"
          value={reimbursementData.RoutingNumber}
        />
      </div>

      <div className={styles.inputMarginLast}>
        <PetCloudInput
          ariaProps={{
            'aria-label': t('reimbursementSection.editModal.accountNumber'),
          }}
          error={accountNumberError}
          id="bankAccountNumber"
          inputRef={bankAccountRef}
          onBlur={handleAccountNumberChange}
          onChange={handleAccountNumberChange}
          onKeyDown={handleArrowKeyPressed()}
          pattern="[0-9]*"
          placeholder={t('reimbursementSection.editModal.accountNumber')}
          title={t('reimbursementSection.editModal.accountNumber')}
          type="number"
          value={reimbursementData.AccountNumber}
        />

        <PetCloudInput
          ariaProps={{
            'aria-label':
              t('reimbursementSection.editModal.confirmAccountNumber'),
          }}
          error={confirmAccountNumberError}
          id="confirmBankAccountNumber"
          inputRef={confirmAccountRef}
          onBlur={handleConfirmAccountNumberChange}
          onChange={handleConfirmAccountNumberChange}
          onKeyDown={handleArrowKeyPressed()}
          pattern="[0-9]*"
          placeholder={t('reimbursementSection.editModal.confirmAccountNumber')}
          title={t('reimbursementSection.editModal.confirmAccountNumber')}
          type="number"
          value={reimbursementData.ConfirmAccountNumber}
        />
      </div>

      <EditReimbursementModalButtons
        finalStep
        handleEditReimbursementAccept={handleEditReimbursementAccept}
        handleEditReimbursementCancel={handleEditReimbursementCancel}
        handleEditReimbursementSuccess={handleEditReimbursementSuccess}
        isFormInvalid={isBankFormInvalid}
        reimbursementMethodUpdateSuccess={reimbursementMethodUpdateSuccess}
        updatingReimbursementMethod={updatingReimbursementMethod}
      />
    </form>
  );
};

export { DirectDepositContent };
